export const OicpCpoAuthenticationModeValues = [
  'NFC RFID Classic',
  'NFC RFID DESFire',
  'PnC',
  'REMOTE',
  'Direct Payment',
  'No Authentication Required',
] as const;

export type OicpCpoAuthenticationMode =
  typeof OicpCpoAuthenticationModeValues[number];

export const OicpCpoPaymentOptionValues = [
  'No Payment',
  'Direct',
  'Contract',
] as const;

export type OicpCpoPaymentOption =
  typeof OicpCpoPaymentOptionValues[number];

export const OicpCpoValueAddedServiceValues = [
  'Reservation',
  'DynamicPricing',
  'ParkingSensors',
  'MaximumPowerCharging',
  'PredictiveChargePointUsage',
  'ChargingPlans',
  'RoofProvided',
  'None',
] as const;

export type OicpCpoValueAddedService =
  typeof OicpCpoValueAddedServiceValues[number];

export const OicpCpoAccessibilityValues = [
  'Free publicly accessible',
  'Restricted access',
  'Paying publicly accessible',
  'Test Station',
] as const;

export type OicpCpoAccessibility =
  typeof OicpCpoAccessibilityValues[number];

export const OicpCpoAccessibilityLocationValues = [
  'OnStreet',
  'ParkingLot',
  'ParkingGarage',
  'UndergroundParkingGarage',
] as const;

export type OicpCpoAccessibilityLocation =
  typeof OicpCpoAccessibilityLocationValues[number];

export const OicpCpoCalibrationLawDataAvailabilityValues = [
  'Local',
  'External',
  'Not Available',
] as const;

export type OicpCpoCalibrationLawDataAvailability =
  typeof OicpCpoCalibrationLawDataAvailabilityValues[number];

export interface IOicpCpoEntityFieldsBase {
  authenticationModes?: OicpCpoAuthenticationMode[];
  paymentOptions?: OicpCpoPaymentOption[];
  valueAddedServices?: OicpCpoValueAddedService[];
  hotlinePhoneNumber?: string;
  accessibility?: OicpCpoAccessibility;
  accessibilityLocation?: OicpCpoAccessibilityLocation;
  renewableEnergy?: boolean;
  calibrationLawDataAvailability?: OicpCpoCalibrationLawDataAvailability;
}

export interface IOicpCpoInstallationFields extends IOicpCpoEntityFieldsBase {
  chargingPoolId?: string;
}

export interface IOicpCpoStationFields extends IOicpCpoEntityFieldsBase {}
